// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.security-visitors-page {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.security-visitors-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}

.security-visitors-header h1,
.security-visitors-header p {
  margin: 0;
}

.security-visitors-header p {
  color: #64748b;
  margin-top: 6px;
}

.security-visitors-table-wrap {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: auto;
}

.security-visitors-table {
  min-width: 900px;
}`, "",{"version":3,"sources":["webpack://./src/styles/SecurityVisitorsPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".security-visitors-page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n.security-visitors-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.security-visitors-header h1,\r\n.security-visitors-header p {\r\n  margin: 0;\r\n}\r\n\r\n.security-visitors-header p {\r\n  color: #64748b;\r\n  margin-top: 6px;\r\n}\r\n\r\n.security-visitors-table-wrap {\r\n  background: #fff;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 14px;\r\n  overflow: auto;\r\n}\r\n\r\n.security-visitors-table {\r\n  min-width: 900px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
